export enum SocialMatchFormat {
  THREE_SETS_SIX_GAMES = 'SET3-S:6/TB7',
  TWO_SETS_SIX_GAMES = 'SET3-S:TB7-F:TB10',
  TWO_SETS_FOUR_GAMES = 'SET3-S:4/TB5@3',
  ONE_SET_SIX_GAMES = 'SET1-S:6/TB7',
  TEN_POINTS = 'SET1-S:TB10',
}
